// ----------------------------------------------------------------------------
// Snippet: Card
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import '../../snippets/_containers/css-grid/css-grid';
import '../../snippets/background-media/background-media';

// Styles
import './_card.scss';
import $ from 'jquery';


$(function() {
    //Makes entire product card clickable
    $(".card--product").on("click", function(e) {
        var cardTarget = $(e.target);
        var cardArticle = cardTarget.closest('.card--product');
        var card = {
            $cardWrapper     :  $(cardArticle).find('.card__wrapper'),
            $cardImageWrapper:  $(cardArticle).find('.card__image-wrapper'),
            $cardButton:        $(cardArticle).find('.card__button'),
        };
        
        if(!cardTarget.hasClass('card__button')){
            var cardLink = card.$cardImageWrapper.attr('href');
            window.location.href = cardLink;
        }
    }); 
    
    //Add empty stars UI if there are no Yotpo reviews 
    setTimeout(() => {
        $(".yotpo.yotpo-wrapper--product-card.bottomLine.yotpo-small .yotpo-display-wrapper").each(function () {
            var starWidget = $(this);
            //If product has 0 reviews add empty star icons
            if (!starWidget.find(".standalone-bottomline").length > 0) {
                $(this).html('\
                    <div class="standalone-bottomline" data-source="default" tabindex="-1">\
                        <div class="yotpo-bottomline pull-left  star-clickable" tabindex="0">\
                            <span class="yotpo-stars">\
                                <span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>\
                                <span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>\
                                <span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>\
                                <span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>\
                                <span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>\
                                <span class="sr-only">no reviews</span>\
                            </span>\
                            <a href="javascript:void(0)" class="text-m" aria-label="no reviews" tabindex="-1">0 Reviews</a>\
                        </div>\
                    </div>\
                '); 
            }
        });
    }, 1250);
});